import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ChangeDetectorRef, AfterContentChecked, ViewChild, ElementRef
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { User } from '@app/modules/core/interfaces/user';
import { TRAVELER_FORM_INPUTS } from '@booking/constants/forms.constants';
import { UserGender } from '@booking/entities/user-gender';
import { FormInputsService } from '@reservation/services/form-inputs.service';
import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import { RadioButtonFailedType } from '@design-system/components/organisms/radio-button/entities/radio-button.types';

@Component({
  selector: 'app-gender-selector',
  templateUrl: './gender-selector.component.html',
  styleUrls: ['./gender-selector.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenderSelectorComponent implements AfterContentChecked {

  @Input() user: User;
  @Input() form: UntypedFormGroup;
  @Input() isSubmitted: boolean;
  @Input() idSelector: string = TRAVELER_FORM_INPUTS.GENDER;
  @Input() male: UserGender = UserGender.Male;
  @Input() female: UserGender = UserGender.Female;

  @ViewChild('maleCheckbox') maleCheckbox: ElementRef;
  @ViewChild('femaleCheckbox') femaleCheckbox: ElementRef;

  public readonly typographyFontSize = TypographyFontSize;
  public readonly typographyColor = TypographyColor;

  public readonly radioButtonFailedType = RadioButtonFailedType.Warning;

  constructor(
    private readonly formInputsService: FormInputsService,
    private readonly cdRef: ChangeDetectorRef
  ) { }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get isMale(): boolean {
    return this.form?.get(this.idSelector)?.value === UserGender.Male;
  }

  get isFemale(): boolean {
    return this.form?.get(this.idSelector)?.value === UserGender.Female;
  }

  public setValue(value: UserGender): void {
    this.form?.get(this.idSelector)?.setValue(value);
    this.form?.updateValueAndValidity();
  }

  public addErrorClass(field: string): { [key: string]: boolean } {
    return this.formInputsService.addErrorClass(field, this.form, this.isSubmitted);
  }

}
